import classNames from "classnames";
import { ActionIcon } from "PFComponents/action_icon";
import SimpleBadge from "PFComponents/badges_list/simple_badge";
import { Button } from "PFComponents/button";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import css from "../overwrites.module.scss";
import ResetButton from "../reset_button";

const SkillsRow = ({ name, collection, exportableProfile, cfName, deselectedSkills, forceUpdate }) => {
  const { t } = useTranslation();

  const [showSection, setShowSection] = useState(true);

  const handleDeselect = (id) => {
    if (deselectedSkills.includes(id)) {
      exportableProfile.setUnselectedSkills(deselectedSkills.filter((item) => item !== id));
      forceUpdate();
    } else {
      exportableProfile.setUnselectedSkills([...deselectedSkills, id]);
      forceUpdate();
    }
  };

  useEffect(() => {
    const rawCustomField = exportableProfile.getRawCustomField(cfName);
    const filteredCF = rawCustomField.filter((cf) => !deselectedSkills.includes(cf.id));
    const vals = filteredCF.map(({ text }) => text).join("\r ");
    exportableProfile.updateCustomFieldValue(cfName, vals);
  }, [deselectedSkills]);

  const hasSectionDeselectes = collection.some((item) => deselectedSkills.includes(item.id));

  const handleDeselectAll = useCallback(() => {
    const collectionIds = collection.map((item) => item.id);
    exportableProfile.setUnselectedSkills([...deselectedSkills, ...collectionIds]);
    forceUpdate();
  }, [collection, deselectedSkills, exportableProfile, forceUpdate]);

  return (
    <div className={css.skillsRow}>
      <div className={css.skillsCategory}>
        <div className={css.label}>
          {name} ({collection.length})
          <Button kind="blank" onClick={() => setShowSection((prev) => !prev)} className={css.showHideButton}>
            {t(showSection ? "hideAll" : "showAll")}
          </Button>
        </div>
        {hasSectionDeselectes ? (
          <ResetButton
            onClick={() => {
              const collectionIds = collection.map((item) => item.id);
              exportableProfile.setUnselectedSkills(
                deselectedSkills.filter((item) => !collectionIds.includes(item))
              );
              forceUpdate();
            }}
          />
        ) : (
          <Button text={t("deselectAll")} kind="text" onClick={handleDeselectAll} />
        )}
      </div>
      <div className={classNames(css.section, { [css.hidenSection]: !showSection })}>
        {collection.map((item, index) => {
          const isDeselected = deselectedSkills.includes(item.id);
          return (
            <SimpleBadge
              key={`${item.text}+${index}`}
              text={item.text}
              style={{ opacity: isDeselected ? 0.5 : 1 }}
              onClick={() => handleDeselect(item.id)}
              icon={
                <ActionIcon
                  name={isDeselected ? "add" : "cross"}
                  size="sm"
                  onClick={(event) => {
                    handleDeselect(item.id);
                    event.stopPropagation();
                  }}
                />
              }
            />
          );
        })}
      </div>
    </div>
  );
};

SkillsRow.propTypes = {
  name: PropTypes.string,
  collection: PropTypes.array,
  exportableProfile: PropTypes.object,
  cfName: PropTypes.string,
  deselectedSkills: PropTypes.array,
  forceUpdate: PropTypes.func
};

export default SkillsRow;
